module.exports = __webpack_public_path__ + "assets/9ec24bd081ef89afe4adeaecffe4528c.mp4";